// redux/Modules/modules/reducer.js

import {
  MODULE_INSERT,
  MODULE_UPDATE,
  MODULES_LIST,
  MODULES_PAGINATION,
} from "./constant";

const initialState = {
  loading: false,

  modulesList: [],

  pagination: {
    totalRecord: 0,
    currentRecord: 0,
    currentPage: 1,
    nextPage: 0,
    totalPage: 1,
  },

  lastInsertedModule: null,
  lastUpdatedModule: null,

  error: null,
};

const modulesReducer = (state = initialState, action) => {
  switch (action.type) {
    // ======================================
    // MODULES LIST
    // ======================================

    case MODULES_LIST:
      return {
        ...state,
        modulesList: action.payload || [],
      };

    // ======================================
    // PAGINATION
    // ======================================

    case MODULES_PAGINATION:
      return {
        ...state,
        pagination: action.payload || {},
      };

    // ======================================
    // INSERT
    // ======================================

case MODULE_INSERT:
  return {
    ...state,
    lastInsertedModule: action.payload,
  };

    // ======================================
    // UPDATE
    // ======================================
    case MODULE_UPDATE:
      return {
        ...state,
        lastUpdatedModule: action.payload,
      };

    // case MODULE_UPDATE:
    //   return {
    //     ...state,
    //     modulesList: state.modulesList.map((m) =>
    //       m.MODULE_ID === action.payload?.data?.MODULE_ID
    //         ? action.payload.data
    //         : m,
    //     ),
    //     lastUpdatedModule: action.payload,
    //   };

    // ======================================
    // DEFAULT
    // ======================================

    default:
      return state;
  }
};

export default modulesReducer;
